import { render, staticRenderFns } from "./PropertyItem.vue?vue&type=template&id=c74c08da"
import script from "./PropertyItem.vue?vue&type=script&lang=js"
export * from "./PropertyItem.vue?vue&type=script&lang=js"
import style0 from "./PropertyItem.vue?vue&type=style&index=0&id=c74c08da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports